import React from 'react';
import styled from "styled-components";
import { FreeBusyStatus } from '@features/whereabouts/services/WhereaboutOptions';
import { ToggleableOutlineButton } from "@shared/ui/atoms/buttons/ToggleableOutlineButton";
import { tablet } from "@shared/ui/atoms/MediaQueries";
import { BodySmall } from "@shared/ui/atoms/fonts/Body";
import { Trans } from "react-i18next";

export function WhereaboutsAvailabilityToggle(props: Props) {
  const {onSelect, selected} = props;

  const onClick = (view: FreeBusyStatus) => {
    if (props.disabled) {
      return;
    }

    onSelect(view);
  }

  return (
    <>
      <ButtonRow>
        <ToggleableOutlineButton isActive={selected === FreeBusyStatus.FREE}
                                 click={() => onClick(FreeBusyStatus.FREE)}
                                 disabled={!!props.disabled}
                                 text="button.free" />
        <ToggleableOutlineButton isActive={selected === FreeBusyStatus.TENTATIVE}
                                 disabled={!!props.disabled}
                                 click={() => onClick(FreeBusyStatus.TENTATIVE)}
                                 text="button.partial" />
        <ToggleableOutlineButton isActive={selected === FreeBusyStatus.BUSY}
                                 disabled={!!props.disabled}
                                 click={() => onClick(FreeBusyStatus.BUSY)}
                                 text="button.not-available" />
      </ButtonRow>
      <ButtonRow>
        <ToggleableOutlineButton isActive={selected === FreeBusyStatus.WORKING_ELSEWHERE}
                                 disabled={!!props.disabled}
                                 click={() => onClick(FreeBusyStatus.WORKING_ELSEWHERE)}
                                 text="button.working-elsewhere" />
        <ToggleableOutlineButton isActive={selected === FreeBusyStatus.OOF}
                                 disabled={!!props.disabled}
                                 click={() => onClick(FreeBusyStatus.OOF)}
                                 text="button.oof" />
      </ButtonRow>
      {selected === FreeBusyStatus.FREE && <BodySmall><Trans i18nKey="whereaboutsAvailability.show-as-free" /></BodySmall>}
      {selected === FreeBusyStatus.TENTATIVE && <BodySmall><Trans i18nKey="whereaboutsAvailability.show-as-tentative" /></BodySmall>}
      {selected === FreeBusyStatus.BUSY && <BodySmall><Trans i18nKey="whereaboutsAvailability.show-as-busy" /></BodySmall>}
      {selected === FreeBusyStatus.OOF && <BodySmall><Trans i18nKey="whereaboutsAvailability.show-as-oof" /></BodySmall>}
      {selected === FreeBusyStatus.WORKING_ELSEWHERE && <BodySmall><Trans i18nKey="whereaboutsAvailability.show-as-working-elsewhere" /></BodySmall>}

    </>
  )
}

interface Props {
  onSelect: (status: FreeBusyStatus) => any;
  selected: FreeBusyStatus;
  disabled?: boolean;
}

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 12px;
  width: 100%;
  & > * {
    width: 162px;
  }
  button {
    flex: 1;
    @media (${tablet}) {
      min-width: unset;
    }
  }
`

